import React from "react";

const SvgWorse = props => (
  <svg viewBox="0 0 430.91 216.62" {...props}>
    <defs>
      <linearGradient
        id="worse_svg__a"
        x1={276.22}
        y1={39.61}
        x2={152.5}
        y2={39.61}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#24defa" />
        <stop offset={1} stopColor="#61b4e4" />
      </linearGradient>
      <linearGradient
        id="worse_svg__b"
        x1={284.06}
        y1={12.75}
        x2={344.48}
        y2={117.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00c59e" />
        <stop offset={1} stopColor="#9fd300" />
      </linearGradient>
      <linearGradient
        id="worse_svg__c"
        x1={145.3}
        y1={13.81}
        x2={85.02}
        y2={118.21}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ffd200" />
        <stop offset={1} stopColor="#ff4e00" />
      </linearGradient>
      <linearGradient
        id="worse_svg__d"
        x1={381.94}
        y1={210.59}
        x2={381.94}
        y2={92.44}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#aadc00" />
        <stop offset={0.02} stopColor="#a0e600" />
        <stop offset={1} stopColor="#9fd300" />
      </linearGradient>
      <linearGradient
        id="worse_svg__e"
        x1={48.56}
        y1={93.56}
        x2={48.56}
        y2={210.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f34454" />
        <stop offset={1} stopColor="#c31021" />
      </linearGradient>
    </defs>
    <g data-name="Vrstva 2">
      <g data-name="Layer 1">
        <g data-name="Layer 1">
          <path
            d="M215.44 0a215.49 215.49 0 00-62.94 9.34l22.69 69.88a139.77 139.77 0 0178.31-.56l22.72-69.91A215.5 215.5 0 00215.44 0z"
            fill="url(#worse_svg__a)"
          />
          <path
            d="M285.75 11.78L263 81.69a142.31 142.31 0 0164 45.81l59.28-43.06a215.84 215.84 0 00-100.53-72.66z"
            fill="url(#worse_svg__b)"
          />
          <path
            d="M143 12.5a215.84 215.84 0 00-99.22 73.06l59.28 43.07a142.36 142.36 0 0162.69-46.16z"
            fill="url(#worse_svg__c)"
          />
          <path
            d="M392.28 92.44L333 135.5a141.58 141.58 0 0124.44 75.09h73.5a214.33 214.33 0 00-38.66-118.15z"
            fill="url(#worse_svg__d)"
          />
          <path
            d="M37.78 93.56A214.5 214.5 0 000 210.59h73.47a141.42 141.42 0 0123.66-73.93z"
            fill="url(#worse_svg__e)"
          />
        </g>
        <path
          d="M227.65 185.42l-1.19-1-.07-.07c-.35-.29-.68-.58-1-.85l-7.64-6.3-73-60.18 54.44 89.26c.2.38.43.74.67 1.11.07.14.16.27.24.4l.63 1a18.54 18.54 0 001.23 1.61 18 18 0 0027.16-23.56 17.72 17.72 0 00-1.47-1.42z"
          fill="#444749"
        />
      </g>
    </g>
  </svg>
);

export default SvgWorse;

